(() => {
  const storageKey = 'ic_attribution_v1';
  const keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

  const read = () => {
    try { return JSON.parse(sessionStorage.getItem(storageKey) || '{}'); }
    catch (_) { return {}; }
  };

  const params = new URLSearchParams(window.location.search);
  const captured = read();
  let changed = false;
  keys.forEach((key) => {
    const value = params.get(key);
    if (value) {
      captured[key] = value.slice(0, 120);
      changed = true;
    }
  });
  if (changed) {
    captured.landing_path = (window.location.pathname + window.location.search).slice(0, 255);
    sessionStorage.setItem(storageKey, JSON.stringify(captured));
  }

  const syncToCart = async () => {
    const attribution = read();
    if (!attribution.utm_source) return;
    try {
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((response) => response.json());
      if (!cart || !cart.item_count) return;

      const attributes = {};
      Object.entries(attribution).forEach(([key, value]) => {
        const attributeKey = 'ic_' + key;
        if (cart.attributes?.[attributeKey] !== value) attributes[attributeKey] = value;
      });
      if (!Object.keys(attributes).length) return;

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes })
      });
    } catch (_) {
      // Attribution must never interrupt checkout or cart interactions.
    }
  };

  [600, 2200, 5000].forEach((delay) => window.setTimeout(syncToCart, delay));
  document.addEventListener('cart:updated', syncToCart);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') syncToCart();
  });
})();